/**
 * Labstep
 *
 * @module components/AccessKey/Action/Menu
 * @desc Menu of all actions for AccessKey
 */

import { AccessKeyActionDelete } from 'labstep-web/components/AccessKey/Action/Delete';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { AccessKeyActionMenuProps } from './types';

export const AccessKeyActionMenu: React.FC<
  AccessKeyActionMenuProps
> = ({ accessKeyItem, actions = [] }) => (
  <ActionMenu>
    {actions.includes('delete') && (
      <AccessKeyActionDelete accessKeyItem={accessKeyItem} />
    )}
  </ActionMenu>
);

AccessKeyActionMenu.defaultProps = {
  actions: [],
};
